import { isBrowser, login as ZpayLogin } from '@croquiscom-pvt/web2app';

import { getConfig } from '@common/config';
import { isKakaotalk, isToss, isZigzag } from '@common/device-manager';

import { loginKakao } from './loginKakao';
import { loginToss } from './loginToss';

const config = getConfig();

export type GotoLoginParams = {
  redirect_url?: string;
  auth_login_route?: string;
  use_deep_link?: boolean;
  push_route?: boolean;
};

/**
 *
 * @param auth_login_route 지정하지 않으면 config의 auth_login_route 또는 기본값(/auth/login)으로 이동
 * @param use_deep_link 딥링크 대응 (기획전 페이지)
 * @param redirect_url 로그인 성공 후 돌아갈 페이지, 지정될 경우 ?redirect= 쿼리스트링이 붙으니 사용하는 앱의 인증관련 로직도 이에 맞춰야함
 * @param push_route 브라우저에서 로그인 후 돌아갈 페이지를 푸시 이동으로 처리할지 여부
 * @returns void, 로그인 딥링크, 또는 로그인 웹링크로 이동
 */
export function gotoLogin({ auth_login_route, redirect_url, use_deep_link, push_route }: GotoLoginParams = {}) {
  const login_route = auth_login_route ?? config.auth_login_route ?? '/auth/login';
  if (!isBrowser()) {
    return console.log('[Error] gotoLogin not available in server');
  }
  if (isZigzag()) {
    if (use_deep_link) {
      return window.location.assign('zigzag://open/login');
    }

    return ZpayLogin();
  }
  if (isKakaotalk()) {
    loginKakao(redirect_url);
    return;
  }

  if (isToss()) {
    loginToss();
    return;
  }
  const redirect = !redirect_url ? '' : `?redirect=${redirect_url}`;

  if (push_route) {
    window.location.assign(login_route + redirect);
  } else {
    window.location.replace(login_route + redirect);
  }
}
